import type { UserResponse } from '~/lib/bff';
import type { RosterPermissionType } from '~/modules/artist-roster/types';
import type { LabelData } from '~/modules/artist-roster/types';

// Checks if the user has the target permission for any of the labels.
export const doLabelsHavePermission = (
  labels: LabelData[],
  permissions: UserResponse['permissions'],
  targetPermission: RosterPermissionType,
): boolean => {
  return labels.some((label) =>
    permissions[label.labelId.toString()]?.includes(targetPermission),
  );
};
